import tribunalAPI from "../../api/tribunalAPi";
import {
  BodyMoveSolicitudToDemanda,
  BodyPostSolicitudDemanda,
  BodySolicitudDemanda,
  BodyUpdateSolicitudDemanda,
  InstanciaReponse,
  JuiciosResponse,
  MateriaResponse,
  OficialiaResponse,
  RegionesResponse,
  ResponseMoveSolcitudToDemanda,
  ResponseSolicitudDemanda,
  ResponseSolicitudDemandaById,
  ResponseSolicitudDemandaLaboral,
  SolicitudDemandaResponse,
  ViasResponse,
} from "interfaces/demandas/demandasInterface";
import { UploadFileResponse } from "../../interfaces/demandas/demandasInterface";

const getRegiones = async () => {
  let url = "/demandas/obtener/regiones";
  return await tribunalAPI.get<RegionesResponse>(url);
};

const getOficialiaPoregiones = async (cveRegion: number) => {
  let url = `demandas/obtener/oficialias/${cveRegion}`;
  return await tribunalAPI.get<OficialiaResponse>(url);
};

const getMaterias = async (cveOficialia: number) => {
  let url = `/demandas/obtener/materias/${cveOficialia}`;
  return await tribunalAPI.get<MateriaResponse>(url);
};

const getInstanciasOficialia = async (
  cveOficialia: number,
  cveMateria: number
) => {
  let url = `/demandas/obtener/instancias/${cveOficialia}?cveMateria=${cveMateria}`;
  return await tribunalAPI.get<InstanciaReponse>(url);
};

const getInstanciasOficialiaDemandas = async (
  cveOficialia: number,
) => {
  let url = `/demandas/obtener/instancias/${cveOficialia}`;
  return await tribunalAPI.get<InstanciaReponse>(url);
};

const getViasMateria = async (cveMateria: number, withHistoricos: string) => {
  let url = `/demandas/obtener/vias/${cveMateria}?${withHistoricos}`;
  return await tribunalAPI.get<ViasResponse>(url);
};

const getJuicios = async (cveMateria: number, cveModalidad: number) => {
  let url = `/demandas/obtener/juicios/${cveMateria}/${cveModalidad}`;
  return await tribunalAPI.get<JuiciosResponse>(url);
};

const getPermisoJuicios = async (cveAdscripcion: number, cveLiti: number) => {
  let url = `/demandas/obtener/litis-excluidas/${cveAdscripcion}/${cveLiti}`;
  return await tribunalAPI.get(url);
};

const getSolicitudesDemandas = async (body: BodySolicitudDemanda) => {
  let url = "/demandas/obtener/solicitud-demandas";
  return await tribunalAPI.get<ResponseSolicitudDemanda>(url, {
    params: {
      page: body?.page,
      perPage: body?.perPage,
      querySearch: body.querySearch,
      estatus: body.estatus,
    },
  });
};

const getSolicitudesDemandasLaborales = async (body: BodySolicitudDemanda) => {
  let url = "/demandas/obtener/demanda-laboral";
  return await tribunalAPI.get<ResponseSolicitudDemandaLaboral>(url, {
    params: { page: body?.page, perPage: body?.perPage || "" },
  });
};

const postUploadFile = async <T>(body: T) => {
  let url = "/demandas/iniciales/documentos";
  return await tribunalAPI.post<UploadFileResponse>(url, body);
};

const getFiles = async (params: { path: string }) => {
  let url = "/demandas/iniciales/documentos";
  return await tribunalAPI.get(url, {
    params: params,
    responseType: "arraybuffer",
  });
};

const postSolicitudDemanda = async (body: BodyPostSolicitudDemanda) => {
  let url = "/demandas/iniciales";
  return await tribunalAPI.post<SolicitudDemandaResponse>(url, body);
};

const deleteFileUploadded = async (file: {
  path: string;
  idFirmaDocumento: number;
}) => {
  let url = "/demandas/iniciales/documentos";
  return await tribunalAPI.delete(url, {
    params: file,
  });
};

const postMoveSolicitudToDemanda = async (body: BodyMoveSolicitudToDemanda) => {
  let url = `/demandas/iniciales/guardar-demanda/${body.solicitudDemanda}`;
  return await tribunalAPI.post<ResponseMoveSolcitudToDemanda>(url, body);
};

const putUpdateSolicitudDemanda = async (body: BodyUpdateSolicitudDemanda) => {
  let url = "/demandas/iniciales";
  return await tribunalAPI.put<SolicitudDemandaResponse>(url, body);
};

const getSolicitudDemandaById = async (idSolicitudDemanda: number) => {
  let url = `/demandas/iniciales/${idSolicitudDemanda}`;
  return await tribunalAPI.get<ResponseSolicitudDemandaById>(url);
};

const deleteSolicitudDemanda = async (idSolicitudDemanda: number) => {
  let url = `/demandas/iniciales/${idSolicitudDemanda}`;
  return await tribunalAPI.delete(url);
};

const getAcuseDemandas = async (params: any) => {
  let url = "carga-imagenes/obtener-ruta-imagenes-by-carpeta-judicial";
  return await tribunalAPI.get(url, {
    params,
  });
};

export {
  getSolicitudesDemandas,
  getSolicitudesDemandasLaborales,
  getRegiones,
  getOficialiaPoregiones,
  getMaterias,
  getInstanciasOficialia,
  getViasMateria,
  getJuicios,
  getPermisoJuicios,
  getFiles,
  getSolicitudDemandaById,
  postSolicitudDemanda,
  postUploadFile,
  deleteFileUploadded,
  postMoveSolicitudToDemanda,
  putUpdateSolicitudDemanda,
  deleteSolicitudDemanda,
  getAcuseDemandas,
  getInstanciasOficialiaDemandas,
};
